// src/components/AnimatedSection/AnimatedSection.jsx
import { motion } from "framer-motion";

const AnimatedSection = ({
  children,
  className = "",
  delay = 0,
  direction = "up", // up | down | left | right
  type = "ease", // "spring" or "ease"
}) => {
  const getInitial = () => {
    switch (direction) {
      case "down":
        return { opacity: 0, y: -80, scale: 0.95 };
      case "left":
        return { opacity: 0, x: 80, scale: 0.95 };
      case "right":
        return { opacity: 0, x: -80, scale: 0.95 };
      default:
        return { opacity: 0, y: 80, scale: 0.95 };
    }
  };

  const getTransition = () => {
    if (type === "spring") {
      return {
        type: "spring",
        stiffness: 40,   // slower
        damping: 25,     // smoother
        delay,
      };
    }

    // cinematic smooth animation
    return {
      duration: 0.9,
      ease: "easeOut",
      delay,
    };
  };

  return (
    <motion.div
      initial={getInitial()}
      whileInView={{
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
      }}
      viewport={{ once: true, margin: "-100px" }}
      transition={getTransition()}
      whileHover={{
        scale: 1.015,
        transition: { duration: 0.3 },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedSection;